import { Divider } from 'antd';
import { useTranslate } from '@tolgee/react';
import { SupplementKnowledgeDetailResponse } from 'services/api/supplementKnowledge';
import { BuyerQuestion } from '../Detail/BuyerQuestion';
import { AnswerEditor } from '../Detail/AnswerEditor';
import { AnswerPanel } from '../Detail/AnswerPanel';
import { Section } from '../Detail/Section';
import { SupplementKnowledgeSidebarHeader } from '../Detail/SidebarHeader';

export const ModifyOnChatSidebar = (props: {
  conversation: Conversation.Conversation;
  dataSource: SupplementKnowledgeDetailResponse;
  autoLocate?: boolean;
  onActionDone?: () => void;
}) => {
  const { t } = useTranslate();
  const { conversation, dataSource, autoLocate, onActionDone } = props;
  const { supplementalKnowledgeValue, enable } = dataSource;

  return (
    <div className="flex-1 h-full bg-[#FFFFFF] relative overflow-y-auto flex flex-col">
      <SupplementKnowledgeSidebarHeader dataSource={dataSource} />
      <Divider className="!my-2" />
      <div className="flex-1 pb-[56px] flex flex-col overflow-y-auto">
        <BuyerQuestion
          autoLocate={autoLocate}
          conversation={conversation}
          supplementalKnowledgeValue={supplementalKnowledgeValue}
        />
        <Divider dashed className="!my-4" />
        <AnswerPanel dataSource={dataSource} />
        <Divider className="!my-4" />
        <Section title={t('修改答案')}>
          <AnswerEditor
            region={conversation.region}
            channel={conversation.channel}
            storeId={conversation.storeId}
            enable={enable}
            dataSource={dataSource}
            onActionDone={onActionDone}
          />
        </Section>
      </div>
    </div>
  );
};
